import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { claimsActions } from '../../../../store';

import type { AppDispatch, RootState } from '../../../../store';

// Wraps all bulk-unbillable Redux reads/dispatches for the page so the component
// never touches react-redux or the claims slice directly.
export const useBulkUnbillable = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();

  const loading = useSelector((state: RootState) => state.claims.loading);
  const summary = useSelector((state: RootState) => state.claims.bulkUnbillableSummary);

  // Memoized: used as a useEffect dependency in the page (unmount cleanup).
  const clearSummary = useCallback(() => {
    dispatch(claimsActions.clearBulkUnbillableSummary());
  }, [dispatch]);

  const upload = (file: File) => {
    dispatch(claimsActions.bulkMarkNotesUnbillable({ file, getAccessTokenSilently }));
  };

  return { loading, summary, clearSummary, upload };
};
